import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import md5 from "md5";

const Home = () => {
    const [penId] = useState(() => {
        const id = new Date().getTime().toString();
        const hash = md5(id).slice(0, 15);
        return hash;
    }
    );

    const divStyle = {
        width: "100%",
        height: "calc(100svh - 60px)",
        background: "linear-gradient(180deg, var(--headBackColor), #1c1b4a)",
        display: "grid",
        placeItems: "center",
        position: "relative",
        overflow: "hidden",
        button: {
            padding: "30px 50px",
            fontSize: "50px",
            borderRadius: "10px",
            border: "4px solid",
            color: "#fff",
            borderColor: "#ffffff81",
            background: `linear-gradient(45deg, var(--buttonColor), #1c1b4a)`
        },
        canvas: {
            width: "100%",
            height: "100%",
            position: "absolute",
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        let animationFram;
        const canvas = document.getElementById("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight - 60;

        document.addEventListener("resize", () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight - 60;
        })

        let atoms = [];

        document.addEventListener('mousemove', (e) => {
            let fillStyle = "hsl(" + Math.random() * 360 + "deg, 100%, 50%)";
            fillStyle = "rgb(95 101 241)";
            for (let i = 0; i < 5; i++) {
                atoms.push(new Atom(e.clientX, e.clientY - 60, fillStyle));
            };
        });

        document.addEventListener('mousedown', (e) => {
            let fillStyle = "hsl(" + Math.random() * 360 + "deg, 100%, 50%)";
            fillStyle = "#fff";
            let radius = Math.random() * 8;
            for (let i = 0; i < 10; i++) {
                atoms.push(new Atom(e.clientX, e.clientY - 60, fillStyle, radius));
            };
        });

        function animate() {
            ctx.clearRect(0, 0, window.innerWidth, window.innerHeight)
            atoms.forEach((atom) => {
                atom.draw();
                atom.update();
            })
            animationFram = requestAnimationFrame(animate);
        }

        class Atom {
            constructor(x, y, fillstyle, radius) {
                this.x = x;
                this.y = y;
                this.radius = radius ? radius : Math.random() * 8;
                this.speedx = Math.random() * 4 - 2;
                this.speedy = Math.random() * 4 - 2;
                this.fillstyle = fillstyle;
            }

            update() {
                this.x += this.speedx;
                this.y += this.speedy;
            }

            draw() {
                ctx.beginPath();
                ctx.fillStyle = this.fillstyle;
                ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
                ctx.fill();
            }

        }
        document.querySelector(".homepageButton").addEventListener("click", () => cancelAnimationFrame(animationFram));

        return animate();
    });

    const handlePenId = () => {

    }


    return (
        <div style={divStyle} >
            <Link to={`/magicpen/${penId}`} style={{ zIndex: "1" }}>
                <button className="homepageButton" onClick={handlePenId} style={divStyle.button} title="Start Coding">Start Coding</button>
            </Link>
            <canvas id="canvas" style={divStyle.canvas}></canvas>
        </div>
    );
}

export default Home;